import { useRef, useEffect, useCallback } from 'react';

export type AutoFocusRef = HTMLInputElement | HTMLTextAreaElement | null;

export const useAutoFocus = (length: number) => {
  const inputRefs = useRef<AutoFocusRef[]>([]);

  const setElementRef = useCallback(
    (index: number) => (el: AutoFocusRef) => {
      inputRefs.current[index] = el;
    },
    [],
  );

  useEffect(() => {
    if (length > 0) {
      const lastIndex = Math.max(0, length - 1);
      const lastElement = inputRefs.current.at(lastIndex) || null;
      if (lastElement) {
        lastElement.focus();
      }
    }
  }, [length]);

  return { setElementRef };
};
